import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import Employer from "../../../auth/services/model/Employer";

interface MultiEmployerResponse {
  employers?: Employer[];
}

export const GetMultiEmployerService =
  async (): Promise<MultiEmployerResponse> => {
    const url = "/users/multi_employer_user/employers/";
    const { data } = await axios.get(url);
    return data;
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetMultiEmployerService = () =>
  useQuery<Promise<MultiEmployerResponse>, AxiosError, MultiEmployerResponse>(
    ["GetMultiEmployerService"],
    () => GetMultiEmployerService()
  );

export default useGetMultiEmployerService;
